import React from 'react';
import Button from '../Button';
import FAQrev from '../FAQrev';

function ReferralProgram() {
  return (
    <>
      <div className="relative bg-[url(/public/Referral.png)] bg-contain bg-no-repeat bg-bottom">
        <div className='grid md:grid-cols-2 items-center justify-between'>
          <div className='flex justify-center md:justify-end'>
            <div className='w-full z-10 max-w-full px-4 md:max-w-[384px] lg:max-w-[512px] xl:max-w-[640px] 2xl:max-w-[768px] md:pl-4'>
              <p className='uppercase text-white text-[52px] xl:text-[64px] leading-[1.1] mb-10'>
                Your Network. <br />
                Your Revenue.
              </p>
              <p className='text-white text-lg leading-[1.2] mb-[60px] opacity-80'>
                Turn your network into profit with iQono’s seamless revenue share program.
              </p>
              <div className='flex gap-[30px] flex-col items-start md:flex-row'>
                <Button variant="primary">Get Started</Button>
              </div>
            </div>
          </div>
          <div className='flex justify-center md:justify-end'>
            <img className='object-cover md:w-2/3' src="/Group1707480753.png" alt=''/>
          </div>
        </div>
      </div>
      <div className='bg-[#F6F6F6]'>
        <div className='grid md:grid-cols-2 items-center justify-between'>
          <div className='flex mt-[-15%]'>
            <img className='object-cover w-4/5' src="/referral-bg.png" alt=''/>
          </div>
          <div className='w-full z-10 max-w-full px-4 md:max-w-[384px] lg:max-w-[512px] xl:max-w-[640px] 2xl:max-w-[768px] md:pl-4'>
            <p className='text-[#111021] text-5xl leading-[1.1] mb-10'>
              Start Earning with iQono
            </p>
            <p className='text-[#111021] text-lg leading-[1.2] mb-[60px] opacity-80'>
              Turn your network into opportunity with iQono’s Revenue Share Program. Connect businesses to our next-generation payment solutions built for performance and reliability — and earn recurring commissions on every transaction they process. Simple, transparent, and built to scale.
            </p>
          </div>
        </div>
        <div className='container mx-auto px-4'>
          <div className='flex flex-col md:flex-row justify-between'>
            <div className='max-w-[870px] w-full md:w-1/2'>
              <p className='uppercase text-5xl leading-[1.1] text-[#111021]'>
                Your Journey with iQono
              </p>
              <p className='text-base leading-[1.1] text-[#111021] mt-10 opacity-80'>
                Building Success — Step by Step
              </p>
              <img src='/referral1.png' className='w-[80%]' alt=''/>
            </div>
            <div className='max-w-[705px] w-full md:w-1/2'>
              <div className='flex flex-col gap-10'>
                <div className='flex flex-col gap-5'>
                  <div className='h-[1px] bg-[#11102140]' />
                  <div className='flex gap-[30px] items-start'>
                    <img className='w-[30px] h-[25px]' src='/union4.png' alt=''/>
                    <div className='flex flex-col gap-[30px]'>
                      <p className='text-[#111021] text-2xl leading-[1.1]'>
                        Join iQono
                      </p>
                      <p className='text-[#111021] text-base leading-[1.1] opacity-60'>
                        Connect with our partnership team and discover how you can earn by introducing merchants to iQono’s global payment solutions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='flex flex-col gap-5'>
                  <div className='h-[1px] bg-[#11102140]' />
                  <div className='flex gap-[30px] items-start'>
                    <img className='w-[30px] h-[30px]' src='/union1.png' alt=''/>
                    <div className='flex flex-col gap-[30px]'>
                      <p className='text-[#111021] text-2xl leading-[1.1]'>
                        Introduce Businesses
                      </p>
                      <p className='text-[#111021] text-base leading-[1.1] opacity-60'>
                        Refer businesses that need smarter, more reliable payment solutions — our team will engage directly and handle everything from there.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='flex flex-col gap-5'>
                  <div className='h-[1px] bg-[#11102140]' />
                  <div className='flex gap-[30px] items-start'>
                    <img className='w-[30px] h-[25px]' src='/union5.png' alt=''/>
                    <div className='flex flex-col gap-[30px]'>
                      <p className='text-[#111021] text-2xl leading-[1.1]'>
                        Earn Passive Income
                      </p>
                      <p className='text-[#111021] text-base leading-[1.1] opacity-60'>
                        Receive ongoing commissions from every transaction your introduced business process through iQono. Consistent, transparent, and built for growth.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='h-[1px] bg-[#11102140]' />
              </div>
              <Button variant="primary" className='mt-[60px]'>Get Started</Button>
            </div>
          </div>
          <div className='bg-[url(/public/partners2.png)] bg-contain bg-no-repeat bg-right pt-10 pb-20'>
            <p className='uppercase text-5xl text-[#111021]'>benefits of being our referral</p>
            <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-[60px] gap-5'>
              <div className='flex flex-col bg-[rgba(255,255,255,0.8)] rounded-2xl p-6'>
                <div className='w-8 h-8 flex'>
                  <div className='w-4 h-8 flex flex-col'>
                    <div className='w-4 h-4 bg-[#423ADC]' />
                  </div>
                  <div className='w-4 h-8 flex flex-col justify-end'>
                    <div className='w-4 h-4 bg-[#423ADC]' />
                  </div>
                </div>
                <p className='text-[#111021] text-2xl mt-[60px]'>Lifetime Commissions</p>
                <p className='text-[#111021] text-lg opacity-80 mt-5'>Earn percentage of the merchant’s processing volume for life, providing you with ongoing, predictable income.</p>
              </div>
              <div className='flex flex-col bg-[rgba(255,255,255,0.8)] rounded-2xl p-6'>
                <div className='w-8 h-8 flex'>
                  <div className='w-4 h-8 flex flex-col'>
                    <div className='w-4 h-4 bg-[#423ADC]' />
                  </div>
                  <div className='w-4 h-8 flex flex-col justify-end'>
                    <div className='w-4 h-4 bg-[#423ADC]' />
                  </div>
                </div>
                <p className='text-[#111021] text-2xl mt-[60px]'>Fast Payouts</p>
                <p className='text-[#111021] text-lg opacity-80 mt-5'>Commissions paid weekly, so you don’t have to wait to enjoy your earnings.</p>
              </div>
              <div className='flex flex-col bg-[rgba(255,255,255,0.8)] rounded-2xl p-6'>
                <div className='w-8 h-8 flex'>
                  <div className='w-4 h-8 flex flex-col'>
                    <div className='w-4 h-4 bg-[#423ADC]' />
                  </div>
                  <div className='w-4 h-8 flex flex-col justify-end'>
                    <div className='w-4 h-4 bg-[#423ADC]' />
                  </div>
                </div>
                <p className='text-[#111021] text-2xl mt-[60px]'>Hands-Off Process</p>
                <p className='text-[#111021] text-lg opacity-80 mt-5'>You make the introduction, and we handle the sales, onboarding, and ongoing support.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-[url(/public/refer-bg.png)] bg-cover bg-no-repeat'>
        <div className='container mx-auto px-4 pb-20'>
          <div className='flex flex-col gap-10'>
            <p className='uppercase text-5xl text-white mt-20'>why refer to us?</p>
            <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5'>
              <div className='h-[250px] rounded-2xl bg-[#423ADC0D] border border-[#423ADC0D] p-6 flex flex-col justify-between'>
                <div className='w-[60px] h-[60px] flex items-center justify-center bg-[#423ADC0D] border border-[#423ADC40] rounded-xl'>
                  <img src='/refer1.png' className='w-6' alt=''/>
                </div>
                <p className='text-white text-2xl'>Scalable Income</p>
              </div>
              <div className='h-[250px] rounded-2xl bg-[#423ADC0D] border border-[#423ADC0D] p-6 flex flex-col justify-between'>
                <div className='w-[60px] h-[60px] flex items-center justify-center bg-[#423ADC0D] border border-[#423ADC40] rounded-xl'>
                  <img src='/refer2.png' className='w-6' alt=''/>
                </div>
                <p className='text-white text-2xl'>Zero Costs</p>
              </div>
              <div className='h-[250px] rounded-2xl bg-[#423ADC0D] border border-[#423ADC0D] p-6 flex flex-col justify-between'>
                <div className='w-[60px] h-[60px] flex items-center justify-center bg-[#423ADC0D] border border-[#423ADC40] rounded-xl'>
                  <img src='/refer3.png' className='w-6' alt=''/>
                </div>
                <p className='text-white text-2xl'>Global Reach</p>
              </div>
              <div className='h-[250px] rounded-2xl bg-[#423ADC0D] border border-[#423ADC0D] p-6 flex flex-col justify-between'>
                <div className='w-[60px] h-[60px] flex items-center justify-center bg-[#423ADC0D] border border-[#423ADC40] rounded-xl'>
                  <img src='/refer4.png' className='w-6' alt=''/>
                </div>
                <p className='text-white text-2xl'>Strong Partner Reputation</p>
              </div>
              <div className='h-[250px] rounded-2xl bg-[#423ADC0D] border border-[#423ADC0D] p-6 flex flex-col justify-between'>
                <div className='w-[60px] h-[60px] flex items-center justify-center bg-[#423ADC0D] border border-[#423ADC40] rounded-xl'>
                  <img src='/refer5.png' className='w-6' alt=''/>
                </div>
                <p className='text-white text-2xl'>Transparent Reporting</p>
              </div>
              <div className='h-[250px] rounded-2xl bg-[#423ADC0D] border border-[#423ADC0D] p-6 flex flex-col justify-between'>
                <div className='w-[60px] h-[60px] flex items-center justify-center bg-[#423ADC0D] border border-[#423ADC40] rounded-xl'>
                  <img src='/refer6.png' className='w-6' alt=''/>
                </div>
                <p className='text-white text-2xl'>Mutually Beneficial Partnershiphips</p>
              </div>
            </div>
          </div>
          <div className='mt-40'>
            <FAQrev />
          </div>
          <div className="bg-[#423ADC0D] border border-[#423ADC40] bg-cover bg-no-repeat rounded-3xl flex flex-col md:flex-row items-end">
            <div className='md:w-1/2 flex flex-col items-start gap-10 px-[30px] py-[50px]'>
              <p className='text-5xl leading-[1.1] text-white'>
                <span className='text-[#C6DC3A]'> Start Earning </span>with Every Referral
              </p>
              <p className='text-lg leading-[1.1] text-white opacity-60'>Integrate quickly and scale across markets — no friction, just flow.</p>
              <Button variant="primary">get started</Button>
            </div>
            <div className='w-full md:w-1/2 mt-10 md:mt-0'>
              <img src='/Photoroom7.png' className='' alt=''/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReferralProgram;
